import React from 'react'
import './styles/Loading.css'

const Loading = () => (

	<div className="loader">Loading...</div>
)

export default Loading